import { create } from "zustand";
import { persist } from "zustand/middleware";

type FyState = {
  activeFyId: number;
  activeFyCode: string | null;
  setActiveFy: (id: number, code: string) => void;
  clearActiveFy: () => void;
};

const DEFAULT_FY_ID = Number(import.meta.env.VITE_FY_ID ?? 1);

export const useFyStore = create<FyState>()(
  persist(
    (set) => ({
      activeFyId: DEFAULT_FY_ID,
      activeFyCode: null,
      setActiveFy: (id, code) => set({ activeFyId: id, activeFyCode: code }),
      clearActiveFy: () => set({ activeFyId: DEFAULT_FY_ID, activeFyCode: null })
    }),
    { name: "transport-erp-active-fy" }
  )
);
